<template>
  <button
      class="tw-cursor-pointer itinerary-nav-btn tw-flex tw-flex-nowrap tw-justify-center tw-items-center lg:tw-w-11r sm:tw-w-36 md:tw-w-40 tw-w-full tw-min-w-23 lg:tw-w-10.75r hover:tw-bg-black hover:tw-text-white"
      :class="{'tw-bg-black tw-text-white tw-cursor-auto': isActive}"
  >
    <div v-if="icon" class="tw-mr-1.5">
      <img :src="imgPath">
    </div>
    <span>{{ label }}</span>
  </button>
</template>


<script>
export default {
  name: "ItineraryTabsNavigationButton",
  props: {
    icon: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    imgPath() {
      return require(`@/assets/icons/${this.icon}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "ItineraryTabsNavigationButton";
</style>
